import { lazy, Suspense, useEffect, useState } from 'react';

// The settings surface (8 panels) is only reachable through the
// 'yap:open-settings' event, so its module is fetched on first open. The
// mount-once gate below keeps the dialog mounted between open/close cycles
// afterwards, preserving internal state exactly like the previous
// always-mounted version.
const SettingsDialog = lazy(() =>
    import('./SettingsDialog').then(m => ({ default: m.SettingsDialog })));

/**
 * Settings Host
 *
 * Mounts the Settings panel once for the whole application and opens it via
 * a window event, so any menu or command can trigger it without prop
 * drilling (mirrors ProjectDialogsHost):
 * - 'yap:open-settings' → open the Settings panel
 */
export function SettingsHost() {
    const [open, setOpen] = useState(false);
    const [hasOpened, setHasOpened] = useState(false);

    useEffect(() => {
        const handleOpen = () => setOpen(true);
        window.addEventListener('yap:open-settings', handleOpen);
        return () => window.removeEventListener('yap:open-settings', handleOpen);
    }, []);

    useEffect(() => {
        if (open) setHasOpened(true);
    }, [open]);

    if (!hasOpened) return null;

    return (
        <Suspense fallback={null}>
            <SettingsDialog isOpen={open} onClose={() => setOpen(false)} />
        </Suspense>
    );
}
